import { string } from 'yup'
import { safify } from '../utils/safify'

export enum PostCount {
  Five = '5 posts (1x/week for 5 weeks)',
  Ten = '10 posts (2x/week for 5 weeks)',
  Fifteen = '15 posts (3x/week for 5 weeks)',
  ThirtyWeekdays = '30 posts (1x/day for 1 month, weekdays only)',
  Thirty = '30 posts (1x/day for 1 month)',
}

export const captionCount = string()
  .required()
  .oneOf([PostCount.Five, PostCount.Ten, PostCount.Fifteen, PostCount.ThirtyWeekdays, PostCount.Thirty])
  .default(PostCount.Ten)
  .meta({ autoFill: true, label: 'How many posts do you want to plan?' })
  .transform(safify)
